import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import LoadingState from '../components/LoadingState'

const ValvePage = lazy(() => import('../pages/Valve'))
const ValveStatsPage = lazy(() => import('../pages/ValveStats'))
const ValveMessagesPage = lazy(() => import('../pages/ValveMessages'))

export default [
  {
    path: '/valves/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ValvePage />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/valves/:id/stats',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ValveStatsPage />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/valves/:id/messages',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ValveMessagesPage />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  }
]
